module.exports = __webpack_public_path__ + "img/quick-specialists.88c56ee0.png";